import { Injectable } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ONXEligibilityResponseApplicant, EligibilityResponsePayload } from '../interfaces/eligibility.interface';
import { AppDataPayloadParsed } from '../interfaces/on-exchange-applicant-summary.interface';
import { OnExchangeEnrollPersonI } from '../interfaces/on-exchange-enroll.person.interface';
import { PersonManagerService } from './person-manager.service';
import { OnExchangeEnrollDataTemplate, RAW_OnExchangeEnrollDataTemplate } from '../interfaces/on-exchange.enroll-data.interface';
import { PlansStateStructure } from '../../plan-selection/configs/interfaces/plansStateStructure.interface';
import { PlanAttributes, SummaryView } from '../../plan-selection/interfaces/plan-attributes.interface';
import { Product } from '../../plan-selection/interfaces/product.interface';
import { CurrencyPipe } from '@angular/common';
import { BrandingConfigurationService } from '@ptl/brand';
import { ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from '@ptl/account-management';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { environment } from 'src/environments/environment';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES, AxwayTokenFetcherService } from '@ptl/xhr';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
import { PlanUtilityService } from '../../plan-selection/plan-summary-list/plan-utility.service';
import { OnExchangeApplicationStatus, OnExchangeEnrollResponse } from '../interfaces/on-exchange-enrollment.response-payload.interface';
import { PaymentManagerService } from '../../form-wrappers/plan-enrollment-on-exchange/services/payment-manager.service';
import { ON_EXCHANGE_PAYMENT_METHODS } from '../../shared/interfaces/on-exchange-enrollment-payment-form.interface';
import { OnExchangeEnrollManagerStateStructure, ON_EXCHANGE_ENROLL_MANAGER_REDUCER_NAME, setApplication, setProduct } from '../reducers/enroll-manager.reducer';
import { APPLICANT_RELATION } from '../../plan-selection/services/interfaces/shared/plan-demographics/applicant.interface';
import { API_ENDPOINTS } from 'src/app/shared/constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class EnrollManagerService {

  _application: OnExchangeEnrollDataTemplate = null;
  _product: Product<PlanAttributes, SummaryView> = null;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private personManagerService: PersonManagerService,
    private currencyPipe: CurrencyPipe,
    private brandService: BrandingConfigurationService,
    private entitlementService: EntitlementsHelperService,
    private commonUtilityService: CommonUtilityService,
    private httpClient: HTTPWrapperContext,
    private ngRedux: NgRedux<StateStructure>,
    private planUtilityService: PlanUtilityService,
    private paymentManagerService: PaymentManagerService,
    private axwayTokenFetcherService: AxwayTokenFetcherService
  ) {
    const enrollManagerState: OnExchangeEnrollManagerStateStructure = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_ENROLL_MANAGER_REDUCER_NAME];
    this._application = enrollManagerState.application;
    this._product = enrollManagerState.selectedProduct;
  }

  getProspectId() {
    return this._application.prospectId;
  }
  getApplicationId() {
    return this._application.applicationId;
  }
  getCoverage() {
    return this._application.coverage;
  }
  getProduct() {
    return this._application.product;
  }
  private _getProduct() {
    return this._product;
  }
  getCoverageCounty() {
    const county = this._product.attributes.COUNTY[0].toLowerCase();
    return county.substr(0, 1).toUpperCase() + county.substr(1);
  }
  getContactInformation() {
    return this.personManagerService.query((p: OnExchangeEnrollPersonI) => p.relationship === 'SUBSCRIBER')[0];
  }
  getSpouseDomesticInformation() {
    return this.personManagerService.query((p: OnExchangeEnrollPersonI) => {
      return (
        p.relationship === APPLICANT_RELATION.SPOUSAL_PARTNER ||
        p.relationship === APPLICANT_RELATION.DOMESTIC_PARTNER
      );
    })[0];
  }
  getOnXContactInformation() {
    return this.personManagerService.query((p: OnExchangeEnrollPersonI) => (p as unknown as ONXEligibilityResponseApplicant).contractHolder)[0];
  }
  getEffectiveDate() {
    return this._application.coverage.effectiveDateValue;
  }
  getAppSubmitTimestamp() {
    return this._application.appSubmitTimestamp;
  }
  getPrimaryApplicantInformation() {
    return this.personManagerService.query((person: OnExchangeEnrollPersonI) => {
      return (
        (person as unknown as ONXEligibilityResponseApplicant).isPrimary &&
        !(person as unknown as ONXEligibilityResponseApplicant).contractHolder
      );
    })[0];
  }
  getAdditionalApplicantInformation() {
    return this.personManagerService.query((person: OnExchangeEnrollPersonI) => {
      return !(
        (person as unknown as ONXEligibilityResponseApplicant).isPrimary ||
        (person as unknown as ONXEligibilityResponseApplicant).contractHolder
      );
    });
  }
  getFamilyInformation() {
    return this.personManagerService.query((person: OnExchangeEnrollPersonI) => person.relationship !== 'SUBSCRIBER');
  }
  /** Think OFFX only */
  // getFullFamilyInformation() {
  //     return this.personManagerService.query((person: Applicant) => {
  //         return true;
  //     });
  // }
  /** Think OFFX only */
  // setFamilyInformation(familyObject: Family) {
  //     const persons = this.getFamilyInformation();
  //     const newFamilyObject: Family = {
  //       persons: []
  //     };

  //     if (familyObject.persons.length) {
  //         familyObject.persons.forEach((p: OnExchangeEnrollPersonI, num: number) => {
  //           newFamilyObject.persons.push(Object.assign(p, familyObject.persons[num]));
  //         });
  //         this.personManagerService.updateFamilyMember(newFamilyObject);
  //     } else {
  //         this.personManagerService.put(Object.assign(persons[0], familyObject.persons));
  //     }

  //     this.saveProgress();
  // }
  getChildInformation(): OnExchangeEnrollPersonI {
    return this.personManagerService.query((person: OnExchangeEnrollPersonI) => {
      return person.relationship !== 'SUBSCRIBER';
    })[0];
  }
  // setChildInformation(ChildObject) {
  //     const person = this.getChildInformation();
  //     this.personManagerService.put(Object.assign(person, ChildObject));
  //     this.saveProgress();
  // }
  /** Maybe OFFX only? */
  getOtherHealthInsuranceInformation() {
    return {
      otherHealthInsuranceInformation: this._application.otherHealthInsuranceInformation,
      producer: this._application.producer,
      producerInd: this._application.producerInd,
      producerCollaboration: this._application.producerCollaboration,
      producerCollaborationInd: this._application.producerCollaborationInd
    };
  }


  setPaymentOptionOnX(paymentObject: { paymentOptions: ON_EXCHANGE_PAYMENT_METHODS }) {
    this.paymentManagerService.setPaymentOption(paymentObject, {
      merchantName: this._product.attributes.BILL_MERCHANT_NAME,
      accountNum: this.getPaymentTransactionID()
    });

    this.saveProgress();
  }

  setOnExchangeApplication(data: EligibilityResponsePayload, prospectId: string) {

    this.prune();
    this._application = JSON.parse(JSON.stringify(RAW_OnExchangeEnrollDataTemplate));

    const enrollObj = data;
    const group = enrollObj.applicants;
    let customerData = data.customerData;
    customerData = Object.assign(customerData, { contractHolder: true });

    const region = {
      county: enrollObj.customerData.county,
      state: enrollObj.customerData.state,
      zipcode: enrollObj.customerData.zipCode
    };

    group.forEach((applicant) => {
      if (applicant.isEligible) {
        this.personManagerService.createPersonOnX(applicant, region);
      }
    });

    this.personManagerService.createPersonOnX(customerData);

    this._product = (() => {

      /** From service response ( post-submission ) */
      if (data.selectedPlan) {
        return data.selectedPlan;
      }

      /** From state ( active flow with view-plans action ) */
      let selectedPlan: Product<PlanAttributes, SummaryView>;
      try {
        const planState: PlansStateStructure
          = this.reducerUtilityService.getState('Plans');

        const plansFromState
          = this.planUtilityService.getPlansByProductGroupAsArray();

        selectedPlan = plansFromState.filter(plan => plan.attributes.PLAN_ID === planState.planIdForEnrollment)[0];
      } catch {
        selectedPlan = null;
      }

      return selectedPlan;
    })();

    this._application.coverage.effectiveDateValue = (data as AppDataPayloadParsed).effectiveDate;
    this._application.coverage.premiumAmount
      = this.currencyPipe.transform(this._product.price, 'USD', 'symbol'); // monthlyPremiumDisplay
    this._application.product.region = this._product.attributes.PLAN_REGION[0]; // region;
    this._application.product.groupNumber = this._product.attributes.GROUP_NO;
    this._application.product.planId = this._product.productId;
    this._application.product.lob = '';
    this._application.product.planArea = '';

    this._application.prospectId = prospectId;
  }
  setPaymentTransactionId(response: OnExchangeEnrollResponse) {
    if (response['response']) {
      response = response['response'];
    }

    const policyCreationActivity = response.ApplicantEnrollmentResponse.PolicyActivityMetadata;

    if (policyCreationActivity && policyCreationActivity[0]) {

      const firstActivity = policyCreationActivity[0];

      if (firstActivity.PaymentTransactionID) {
        this._application.transactionId = firstActivity.PaymentTransactionID.value;
      } else {
        throw new Error('Must have a payment transaction ID');
      }
    } else {
      throw new Error('Policy Creation Activity was blank.');
    }

    this.saveProgress();
  }
  getPaymentTransactionID() {
    return this._application.transactionId;
  }
  setSubmissionDate(currentDate: string) {
    // the original code was just: _application.submissionDate;
    // assuming currentDate needs to be assigned to submissionDate
    this._application.submissionDate = currentDate;
  }
  getSubmissionDate() {
    return this._application.submissionDate;
  }
  setFFMPolicyNumber(response: OnExchangeEnrollResponse) {
    if (response['response']) {
      response = response['response'];
    }

    const policyCreationActivity
      = response.ApplicantEnrollmentResponse.policyCreationActivityOrMembersMaintenanceActivityOrPolicyPremiumChangeActivity;

    if (policyCreationActivity && policyCreationActivity[0]) {
      const insuranceApplicant = policyCreationActivity[0].PolicyCreationActivity.EnrollmentGroup.InsuranceApplicant;

      if (insuranceApplicant && insuranceApplicant[0]) {
        this._application.FFMPolicyNumber
          = insuranceApplicant[0].ExchangeAssignedInsuranceApplicantIdentification.IdentificationID.value;
      } else {
        throw new Error('No Insurance Applicant');
      }
    } else {
      throw new Error('No Policy Creation Activity');
    }

    this.saveProgress();
  }
  setAppStatus(statusData: OnExchangeApplicationStatus) {
    this._application.status = statusData.id;
    // 12 they owe money
    // 13 they dont owe money
  }
  getAppStatus() {
    return this._application.status;
  }
  getFFMPolicyNumber() {
    return this._application.FFMPolicyNumber;
  }
  prune() {
    /** Delete APPLICANT and APPLICATION progress */
    this._application = null;
    this.personManagerService.prune();
  }
  hasApplication() {
    return this._application !== null;
  }
  setEffectiveDate(date) {
    this._application.coverage.effectiveDateValue = date;
  }
  saveProgress(familyData?: OnExchangeEnrollDataTemplate) {
    if (familyData && !this._application) {
      this._application = familyData;
    }

    this.ngRedux.dispatch(setApplication(this._application));
    this.ngRedux.dispatch(setProduct(this._product));
    this.paymentManagerService.saveToState();
  }
  getAccountNum() {
    if (this.isChildApplication()) {
      const child = this.getChildInformation();
      return child.ssn.ssnNumber;
    } else {
      const contact = this.getContactInformation();
      return contact.ssn.ssnNumber;
    }
  }
  isChildApplication() {
    return this._application.childOnlyApplication === true;
  }
  isRegularApplication() {
    return !this.isChildApplication();
  }
  isProducerApplication() {
    const information = this.getOtherHealthInsuranceInformation();
    return information.producerInd;
  }
  isPCPEligible() {
    return this._product.attributes.LINE_OF_BUSINESS === 'HMO';
  }
  getRatingEntity() {
    return this._product.attributes.RATING_ENTITY;
  }
  getEntity() {
    return this.getRatingEntity();
  }
  getRegion() {
    return this._application.product.region;
  }
  getGenderOfSubscriber() {
    const contact = this.getContactInformation();
    return contact.gender;
  }
  hasDependents() {
    if (this.getFamilyInformation().length > 0) {
      return true;
    } else {
      return false;
    }
  }
  hasDependentsOnX() {
    if (this.getAdditionalApplicantInformation().length > 0) {
      return true;
    } else {
      return false;
    }
  }
  canUseCC() {
    if (this.isChildApplication()) {
      const child = this.getChildInformation();
      return !child.ssn.noSsnInd;
    } else {
      const contact = this.getContactInformation();
      return !contact.ssn.noSsnInd;
    }
  }
  acceptProducerApplication() {
    this._application.producer.eSignature = true;
  }
  async toJson(selectedMarket: LINE_OF_BUSINESS_ENUM) {
    this._application.persons = this.personManagerService.getAll();

    this._application.product.ratingEntity = this.getRatingEntity();

    const jsonRequestPayload: { baseMessage: any; payload: OnExchangeEnrollDataTemplate; } = {
      baseMessage: {
        uuid: null,
        exchangeType: null,
        headerVersion: '1.0',
        sender: null,
        sentTS: null,
        service: null,
        serviceOperation: null,
        replier: null,
        repliedTS: null,
        username: null,
        returnCode: null,
        returnCodeDescription: null,
        runtimeParms: null,
        processTimings: null,
        businessProcessDifferentiatorId: null,
        statusMsgs: null,
        dataRolesScopedToBusinessContext: null,
        businessContext: null,
        updateAccessIntentEntityScope: null,
        deleteAccessIntentEntityScope: null,
        mdaoEntityScope: null,
        dataRole: null
      },
      payload: null
    };


    /****
      * Encrypt each persons object - deprecated before HCR transfer - just log
      ****/
    for (let index = 0; index < this._application.persons.length; index++) {
      console.log(this._application.persons[index]);
      console.log(JSON.stringify(this._application.persons[index]));
      // _application.persons[index] = btoa(JSON.stringify(_application.persons[index]));
    }

    /** Probably OFFX - don't modify payloads, going forward, always make a version a new object that is typesafe */
    // if (this._application.hasOwnProperty('hasResidency')) {
    //     if (this._application.hasResidency && this._application.hasResidency.toLowerCase().indexOf('yes') > -1) {
    //         this._application.hasResidency = true;
    //     } else {
    //         this._application.hasResidency = false;
    //     }
    // }

    jsonRequestPayload.payload = this._application;

    delete this._application.applicationId;

    /**
     * @TODO - expect these to come from CMS response
     */
    /*
    if (EnrollData.hasOwnProperty('thirdPartyPayer')) {
        this._application.thirdPartyPayer = EnrollData.thirdPartyPayer;

        if (EnrollData.hasOwnProperty('thirdPartyPayerType') && EnrollData.hasOwnProperty('thirdPartyPayerType') !== null) {
            this._application.thirdPartyPayerType = EnrollData.thirdPartyPayerType;
        }

        if (EnrollData.hasOwnProperty('thirdPartyPayerName') && EnrollData.hasOwnProperty('thirdPartyPayerName') !== null) {
            this._application.thirdPartyPayerName = EnrollData.thirdPartyPayerName;
        }
    }

    if (EnrollData.communicationPreferenceIndicator) {
        this._application.communicationPreferenceIndicator = EnrollData.communicationPreferenceIndicator;
    }


    // add ichra field
    if (window.location.href.indexOf('highmark.com') >= 0) {
        this._application.ichra = hmStorage.get('enrollData-thirdParty-type') === 'ICHRA' ? true : false;
    } else {
        this._application.ichra = hmStorage.get('ichra');
    }

    // add qsehra field
    this._application.qsehra = hmStorage.get('qsehra') ? true : false;

    */
    // setting which channel enrollment coming from

    let enrollmentChannel = '';

    const isProducer = this.commonUtilityService.isAgent();
    if (isProducer) {

      if (!selectedMarket) {
        console.warn('Be sure to include the CompactProductAgency on a page where this is used');
      }

      const loginInfo: UserInfoStateStructure
        = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

      const hasRetailStoreEntitlement: boolean
        = await this.entitlementService.entitlementValueForSelectedAgencyByNameAndLob(
          ENTITLEMENTS.RETAIL_STORE,
          selectedMarket, loginInfo?.userInfo?.role as USER_ROLE
        );

      const hasTelesalesEntitlement: boolean
        = await this.entitlementService.entitlementValueForSelectedAgencyByNameAndLob(
          ENTITLEMENTS.TELESALES_AGENT_DP,
          selectedMarket, loginInfo?.userInfo?.role as USER_ROLE
        );

      if (hasRetailStoreEntitlement) {
        enrollmentChannel = 'TeleSales';
        console.log('application submitted by telesales users');
      } else if (hasTelesalesEntitlement) {
        enrollmentChannel = 'Store';
        console.log('application submitted by RetailStore users');
      } else {
        enrollmentChannel = 'Producer';
        console.log('application submitted by Producer users');
      }

    } else {
      enrollmentChannel = 'Consumer';
      console.log('application submitted by visitor( logged in) users');
    }

    this._application.enrollmentChannel = enrollmentChannel;


    /** Not relevant for ONX stuff? */
    // Add SEP form if we are in SEP
    // let SEPdata = hmStorage.get('SEP');
    // if (SEPdata && SEPdata.isSEP) {
    //     let sepData = hmStorage.get('sepEnrollmentForm', {phi: true});
    //     jsonRequestPayload.payload.sepInformation = sepData;
    // }

    return JSON.stringify(jsonRequestPayload);
  }
  async emailConfirmation(optionConfigs: {
    exchangeType: 'ONX' | string;
    TOEMAIL: string;
    overrideTemplate: string;
  }): Promise<unknown> {

    const options = optionConfigs;

    const emailParams = {
      TOEMAIL: '',
      BRAND: '',
      PLAN: false,
      CONFNUMBER: '',
      PRODUCT: '',
      RECEIVEDDATE: '',
      REGIONID: '',
      TEMPLATENAME: '',
      exchangeType: ''
    };


    let defaultEmailInputValue = '';
    if (options.exchangeType && (options.exchangeType === 'ONX')) {
      defaultEmailInputValue = options.TOEMAIL;
    } else {
      defaultEmailInputValue = this._application.persons[0].email;
    }

    emailParams.exchangeType = options.exchangeType;
    emailParams.TOEMAIL = defaultEmailInputValue;
    emailParams.TEMPLATENAME = options.overrideTemplate;


    const brandInfo = this.brandService.getCurrentBrand();
    emailParams.BRAND = brandInfo.cookieBrandCode.toUpperCase();
    emailParams.exchangeType = emailParams.exchangeType + '_' + emailParams.BRAND;

    /**
     * @TODO move this to a config for email functionality
     */
    if (emailParams.TOEMAIL && !(environment.initData.brand.ASPID === 'MINCR')) {

      const payload = JSON.stringify({
        baseMessage: { headerVersion: '1.0' },
        payload: {
          deliveryMethod: 'EMAIL',
          deliveryRecipient: emailParams.TOEMAIL,
          templateName: emailParams.TEMPLATENAME,
          etAttributes: [{
            name: 'Region',
            value: emailParams.BRAND
          }, {
            name: 'exchangeType',
            value: emailParams.exchangeType
          }],
          member: false
        }
      });
      const env = this.commonUtilityService.getTestEnvironment();
      const requestConfigImplementation = new RequestConfigImplementation({
        method: REQUEST_METHODS.POST,
        headers: new HttpHeaders({
          'x-hmhs-test-backend': `wasinter${env}.highmark.com`
        }),
        POST_OR_PUT_PAYLOAD: payload,
        url: this.axwayTokenFetcherService.buildApiUrl(API_ENDPOINTS.EMAIL_SERVICES.SEND_EMAIL_EXACTTARGET, {})
      });

      this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS_V4);
      return this.httpClient.makeRequest<any>(requestConfigImplementation).catch(err => err);
    }

  }



  /** UNUSED FOR ONX
   * Used for Consumer, no link-sharing flow OFF-X
   */
  async submitApplication(selectedMarket: LINE_OF_BUSINESS_ENUM) {

    const requestPayload: {
      baseMessage: any;
      payload: OnExchangeEnrollDataTemplate;
    } = JSON.parse(await this.toJson(selectedMarket));
    console.log('this json submit', requestPayload);
    /** WY SEP stuff, think OFFX only */
    // if (hmStorage.get('isWYSEP') == true) {

    //     let wySepLifeEventDetails = hmStorage.get('wySepLifeEventDetails');
    //     if (wySepLifeEventDetails){
    //         let submissionDate = new Date();
    //         let isAttested = false;
    //         if (wySepLifeEventDetails.dcn){
    //             isAttested = true;
    //         }
    //         let subscriber;
    //         for (let i = 0; i < requestPayload.payload.persons.length; i++){
    //             if (requestPayload.payload.persons[i].relationship.toUpperCase() == 'SUBSCRIBER'){
    //                 subscriber = requestPayload.payload.persons[i];
    //                 break;
    //             }
    //         }
    //         let sepInformationObject = {
    //             fullName:                   subscriber.fullName.firstName + ' ' + subscriber.fullName.lastName,
    //             isAttested,
    //             documentcontrolnumber:      wySepLifeEventDetails.dcn,
    //             sepproducer:                undefined,
    //             dateSubmitted:              submissionDate.toDateString(),
    //             lifeEvent: {
    //                 categoryId:                 '2',
    //                 date:                       wySepLifeEventDetails.lifeEventDate,
    //                 eventCd:                    wySepLifeEventDetails.lifeEventName,
    //                 eventId:                    wySepLifeEventDetails.eventId,
    //                 calculatedEffectiveDate:    wySepLifeEventDetails.effectiveDate,
    //                 requestedEffectiveDate:     wySepLifeEventDetails.effectiveDate,
    //                 ecsReasonCode:              undefined
    //             },
    //         };
    //         requestPayload.payload.sepInformation = sepInformationObject;

    //     }
    // } else {
    //     console.log('cant tell if WY SEP');
    // }

    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      headers: new HttpHeaders({}),
      POST_OR_PUT_PAYLOAD: requestPayload,
      url: `/cmcrst/x-services/application/enroll`
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
    const enrollmentResponse = await this.httpClient.makeRequest<any>(requestConfigImplementation).catch(err => err);

    if (!(enrollmentResponse instanceof HttpErrorResponse)) {

      const returnResponse: {
        baseMessage: {
          returnCode: number;
          serviceOperation: string
        },
        payload: {
          applicationId: string;
        }
      } = JSON.parse(enrollmentResponse);

      if (returnResponse.baseMessage.returnCode === 200) {
        this._application.applicationId = returnResponse.payload.applicationId;

        // appSubmit timestamp
        this._application.appSubmitTimestamp = returnResponse.baseMessage.serviceOperation;

        // Add Email Service Here.
        return 'Application Successfully Submitted';
      } else { return 'Application Submit Failure'; }
    } else { return 'Application Submit Failure'; }
  }

  /** NUNUSED IN ONX
   * Possibly never used
   */
  async submitApplicationProducer(prospectId: string, selectedMarket: LINE_OF_BUSINESS_ENUM) {
    const requestPayload: {
      baseMessage: any;
      payload: OnExchangeEnrollDataTemplate;
    } = JSON.parse(await this.toJson(selectedMarket));
    console.log('this json submit', requestPayload);
    requestPayload.payload.prospectId = prospectId;
    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      headers: new HttpHeaders({}),
      POST_OR_PUT_PAYLOAD: requestPayload,
      url: `/cmcrst/x-services/application/enrollProspect`
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
    const enrollmentResponse = await this.httpClient.makeRequest<any>(requestConfigImplementation).catch(err => err);

    if (!(enrollmentResponse instanceof HttpErrorResponse)) {

      const returnResponse: {
        baseMessage: {
          returnCode: number;
          serviceOperation: string
        },
        payload: {
          applicationId: string;
        }
      } = JSON.parse(enrollmentResponse);

      if (returnResponse.baseMessage.returnCode === 200) {
        this._application.applicationId = returnResponse.payload.applicationId;

        // appSubmit timestamp
        this._application.appSubmitTimestamp = returnResponse.baseMessage.serviceOperation;

        // Add Email Service Here.
        return 'Application Successfully Submitted';
      } else { return 'Application Submit Failure'; }
    } else { return 'Application Submit Failure'; }
  }

  /**
   * UNUSED IN ONX
   * Used for when a NEW (different) PRODUCER works with this prospect to complete the app
   * @param prospectId - maps to prospect from PRODUCER FLOW or LINK-SHARING (email'd app) FLOW
   * @param selectedMarket - maps to LINES OF BUSINESS, any page that uses this service will need this value
   */
  async submitApplicationNewProducer(prospectId: string, selectedMarket: LINE_OF_BUSINESS_ENUM) {
    const requestPayload: {
      baseMessage: any;
      payload: OnExchangeEnrollDataTemplate;
    } = JSON.parse(await this.toJson(selectedMarket));
    console.log('this json submit', requestPayload);
    requestPayload.payload.prospectId = prospectId;

    /** @TODO implement this if needed */
    // check if user coming through agent cube flow from producer
    // if (cookie('agentCubeLead')){
    //     let agentCubeLeadData = JSON.parse(cookie('agentCubeLead'));

    //     if (agentCubeLeadData && agentCubeLeadData.Customer_ID && agentCubeLeadData.OpportunityID) {
    //         requestPayload.payload.customerId = agentCubeLeadData.Customer_ID;
    //         requestPayload.payload.opprotunityId = agentCubeLeadData.OpportunityID;
    //     }
    // }
    console.log('If you are here, please try to update the above logic with the correct location of agent cubed data');
    console.log('producer enroll request payload', JSON.stringify(requestPayload));
    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      headers: new HttpHeaders({}),
      POST_OR_PUT_PAYLOAD: requestPayload,
      url: `/cmcrst/x-services/application/enroll`
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
    const enrollmentResponse = await this.httpClient.makeRequest<any>(requestConfigImplementation).catch(err => err);

    if (!(enrollmentResponse instanceof HttpErrorResponse)) {

      const returnResponse: {
        baseMessage: {
          returnCode: number;
          serviceOperation: string
        },
        payload: {
          applicationId: string;
        }
      } = JSON.parse(enrollmentResponse);

      if (returnResponse.baseMessage.returnCode === 200) {
        this._application.applicationId = returnResponse.payload.applicationId;

        // appSubmit timestamp
        this._application.appSubmitTimestamp = returnResponse.baseMessage.serviceOperation;

        // Add Email Service Here.
        return 'Application Successfully Submitted';
      } else { return 'Application Submit Failure'; }
    } else { return 'Application Submit Failure'; }
  }

}
